import React from 'react';
import { Card, Table, Segmented } from 'antd';
import type { ControlTowerQueryParams } from '@/services/manufacturingControlTower.service';
import { useControlTowerTimeline } from '@/hooks/useManufacturingControlTower';

interface Props {
  period: 'today' | 'week' | 'month';
  onPeriodChange?: (p: 'today' | 'week' | 'month') => void;
  filters?: ControlTowerQueryParams;
}

const ProductionTimeline: React.FC<Props> = ({ period, onPeriodChange, filters }) => {
  const { data, isLoading } = useControlTowerTimeline({ ...filters, period });
  const events = (data as { events?: Record<string, unknown>[] })?.events ?? [];

  return (
    <Card
      id="timeline"
      title="Production timeline"
      extra={
        onPeriodChange ? (
          <Segmented
            size="small"
            value={period}
            onChange={(v) => onPeriodChange(v as 'today' | 'week' | 'month')}
            options={[
              { label: 'Day', value: 'today' },
              { label: 'Week', value: 'week' },
              { label: 'Month', value: 'month' },
            ]}
          />
        ) : null
      }
      style={{ marginTop: 16 }}
    >
      <Table
        size="small"
        loading={isLoading}
        rowKey={(_, i) => String(i)}
        dataSource={events}
        columns={[
          { title: 'Date', dataIndex: 'date', width: 110 },
          { title: 'WO', dataIndex: 'work_order_number', width: 110 },
          { title: 'Operation', dataIndex: 'operation' },
          { title: 'Work center', dataIndex: 'work_center' },
          { title: 'Status', dataIndex: 'status', width: 120 },
          { title: 'Kind', dataIndex: 'kind', width: 80 },
        ]}
        pagination={{ pageSize: 20 }}
      />
    </Card>
  );
};

export default ProductionTimeline;
